<template>
    <div>
        <p>'Timer' {{timer.seconds}}</p>
        <p>{{portfolios}}</p>
    </div>
</template>

<script>
    export default {
        props: {
            portfolios: {
                type: String,
                default: null
            }
        },
        data:() => ({
            books: [],
            countPortfolios: 0,
            timer: {
                seconds: 30,
                func: null
            }
        }),
        created() {
            Object.values(JSON.parse(this.portfolios)).forEach((ele, ind, arr) => {
                this.books.push(ele);
                this.countPortfolios += ele.length;
            });
        },
        mounted() {
            this.timer.func = setInterval(this.timerCountdown, 1000);
        },
        methods: {
            timerCountdown() {
                console.log('countdown');
                if(this.timer.seconds === 0) {
                    this.fetchPortfolio();
                    this.timer.seconds = 30;
                }
                this.timer.seconds--;
            },
            fetchPortfolio() {
                console.log('fetch');

                if(this.countPortfolios === 0) {
                    clearInterval(this.timer.func);
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    }
                });

                $.ajax({
                    url: '',
                    method: '',
                    data: {

                    },
                    success: function(response) {

                    }
                })
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>
